export default __webpack_public_path__ + "static/media/ultrasonic@2x.1a99a759.png";